import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { IoMdArrowBack } from "react-icons/io";
import { hrRecordsApi } from "../../Services/hrRecordsApi";
import { formatDateTimeIST, truthyLabel } from "../hrRecordsHelpers";
import "../../Views/ApprovedPrView.css";
import "../../Views/voyageView.css";
import "../hrRecords.css";

function TrainingStandardViewPage({ isSidebarExpanded }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [standard, setStandard] = useState(null);

  useEffect(() => {
    let mounted = true;

    const run = async () => {
      try {
        const response = await hrRecordsApi.listTrainingStandards({
          include_inactive: true,
        });
        const found = (response || []).find(
          (item) => String(item.id) === String(id),
        );
        if (mounted) {
          setStandard(found || null);
        }
      } catch (error) {
        console.error("Failed to fetch training standard:", error);
      }
    };

    run();

    return () => {
      mounted = false;
    };
  }, [id]);

  return (
    <div
      className={`invoice-request-content-container page-content ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="invoice-request-header-content">
        <div className="invoice-request-heading-content-left-side">
          <Tooltip title="Back" arrow>
            <IoMdArrowBack
              className="back-company"
              onClick={() => navigate("/training/standards")}
            />
          </Tooltip>
          Training Standard Details
        </div>
      </div>

      <div className="data-form-body-voyage">
        {!standard ? (
          <div className="loader-container">
            <div className="loader"></div>
            <div>Loading...</div>
          </div>
        ) : (
          <div className="project-detailss">
            <div className="project-detail-arround">
              <div className="project-details-left-side">
                {[
                  ["Standard Body", standard.standard_body],
                  ["Display Name", standard.display_name],
                  ["Reference No. Label", standard.ref_no_label],
                  ["Section Label", standard.section_label],
                  ["Sort Order", standard.sort_order],
                  ["Description", standard.description],
                  ["Active", truthyLabel(standard.is_active)],
                  ["Created At", formatDateTimeIST(standard.created_at)],
                  ["Updated At", formatDateTimeIST(standard.updated_at)],
                ].map(([label, value]) => (
                  <div className="project-detail" key={label}>
                    <div className="detail-header">{label}:</div>
                    <div className="detail-part-voyage">{value || "N/A"}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TrainingStandardViewPage;
